'use client'

import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { useTranslations } from 'next-intl'

import { Button } from '../../teqplay-ui'
import ModalPortReporter from '../../Modals/ModalPortReporter'

function DiscoverSmartAlertButton() {
  const t = useTranslations('Notifications')
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <>
      <Button variant="brand-primary" onClick={() => setIsModalOpen(true)}>
        <div className="flex items-center gap-2xs">
          <span>{t('discoverSmartAlert')}</span>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </Button>

      <ModalPortReporter isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}

export default DiscoverSmartAlertButton
